import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({selector:'app-qr-self-checkin-fixed', templateUrl:'./qr-self-checkin-fixed.component.html', standalone:false})
export class QrSelfCheckinFixedComponent {
  constructor(private route: ActivatedRoute) {}
  get targetId(): number { return Number(this.route.snapshot.params.serviceId); }
}
